var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',_vm._g(_vm._b({staticClass:"er-card er-card--secondary"},'el-card',_vm.$attrs,false),_vm.inputListeners),[_c('template',{slot:"header"},[_vm._t("header")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }